/* CollecteAvis — panier (tiroir). Refonte 2026-10, plan 33.
   Seulement ce que le Liquid ne peut pas faire, sans réécrire Dawn :
   1. jouer les petites animations une seule fois par ouverture (classe ca-vu) ;
   2. un court fondu du total quand il change (classe ca-maj) ;
   3. « Annuler » après « Supprimer » (on remet la même ligne, avec son commerce). */
(function () {
  var tiroir = document.querySelector('cart-drawer');
  if (!tiroir) return;

  /* 1. Animations une fois par ouverture */
  var minuteurVu;
  new MutationObserver(function () {
    clearTimeout(minuteurVu);
    /* Ne toucher la classe que si elle change : classList.add/remove réécrit l'attribut même sans changement,
       ce qui relancerait l'observateur en boucle (page figée, vu au test du 08/10). */
    if (tiroir.classList.contains('active')) {
      if (!tiroir.classList.contains('ca-vu')) {
        minuteurVu = setTimeout(function () { tiroir.classList.add('ca-vu'); }, 1600);
      }
    } else if (tiroir.classList.contains('ca-vu')) {
      tiroir.classList.remove('ca-vu');
    }
  }).observe(tiroir, { attributes: true, attributeFilter: ['class'] });

  /* 3. Ce qu'on vient de retirer (lu sur le bouton juste avant que Dawn ne le retire) */
  var retire = null;
  var minuteurAnnuler;
  document.addEventListener('click', function (e) {
    var bouton = e.target.closest && e.target.closest('cart-drawer .cart-remove-button');
    if (!bouton) return;
    var proprietes = {};
    try { proprietes = JSON.parse(bouton.getAttribute('data-ca-proprietes') || '{}') || {}; } catch (err) { proprietes = {}; }
    /* Liquid sort les propriétés en paires [[nom, valeur], …] : Shopify attend un objet */
    if (Array.isArray(proprietes)) {
      var objet = {};
      proprietes.forEach(function (p) { if (p && p.length === 2) objet[p[0]] = p[1]; });
      proprietes = objet;
    }
    retire = {
      id: Number(bouton.getAttribute('data-variant-id')),
      quantity: Number(bouton.getAttribute('data-ca-quantite')) || 1,
      properties: proprietes,
      titre: bouton.getAttribute('data-ca-titre') || 'Article'
    };
  }, true);

  function retirerBandeau() {
    clearTimeout(minuteurAnnuler);
    var ancien = tiroir.querySelector('.ca-annuler');
    if (ancien) ancien.remove();
  }

  function montrerAnnuler(article) {
    retirerBandeau();
    var interieur = tiroir.querySelector('.drawer__inner');
    if (!interieur) return;
    var bandeau = document.createElement('div');
    bandeau.className = 'ca-annuler';
    bandeau.setAttribute('role', 'status');
    var texte = document.createElement('span');
    texte.textContent = article.titre + (/^chevalet/i.test(article.titre) ? ' retiré.' : ' retirée.');
    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.textContent = 'Annuler';
    bouton.addEventListener('click', function () { remettre(article, bouton); });
    bandeau.appendChild(texte);
    bandeau.appendChild(bouton);
    interieur.appendChild(bandeau);
    minuteurAnnuler = setTimeout(retirerBandeau, 6000);
  }

  function remettre(article, bouton) {
    bouton.disabled = true;
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: article.id, quantity: article.quantity, properties: article.properties }],
        sections: tiroir.getSectionsToRender().map(function (s) { return s.id; }),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (etat) {
        if (etat.status) { bouton.disabled = false; return; }
        retirerBandeau();
        tiroir.classList.remove('is-empty');
        var items = tiroir.querySelector('cart-drawer-items');
        if (items) items.classList.remove('is-empty');
        tiroir.renderContents(etat);
      })
      .catch(function () { bouton.disabled = false; });
  }

  /* 2 et 3 : après chaque mise à jour du panier par Dawn */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!tiroir.classList.contains('active')) return;
      if (tiroir.classList.contains('ca-maj')) tiroir.classList.remove('ca-maj');
      void tiroir.offsetWidth;
      tiroir.classList.add('ca-maj');
      setTimeout(function () { if (tiroir.classList.contains('ca-maj')) tiroir.classList.remove('ca-maj'); }, 300);
      if (retire && ev && ev.source === 'cart-items') {
        var article = retire;
        retire = null;
        /* Dawn a re-rendu le tiroir : on pose le bandeau au tour suivant */
        setTimeout(function () { montrerAnnuler(article); }, 0);
      }
    });
  }
})();
